import { userService } from "../api/user-auth";

const actions = {
  getScheduleReport({ dispatch }) {
    userService
      .postFile("schedule/current/pdf", { start: new Date().toISOString() })
      .then(
        response => {
          let url = window.URL.createObjectURL(response);
          // window.open(url);
          let a = document.createElement("a");
          a.style = "display: none";
          document.body.appendChild(a);
          a.href = url;
          a.download = "schedule.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        },
      );
  },
  getWeekRoundSheetReport({ dispatch }, dates) {
    userService.postFile("schedule/current/roundsheetpdf", dates).then(
      response => {
        let url = window.URL.createObjectURL(response);
        // window.open(url);
        let a = document.createElement("a");
        a.style = "display: none";
        document.body.appendChild(a);
        a.href = url;
        a.download = "schedule.pdf";
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
};

export const report = {
  namespaced: true,
  actions,
};
